module.exports = __webpack_public_path__ + "static/img/jz1-2.55ad14b.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jz1-2.png
// module id = 414
// module chunks = 0